"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = withWindConfig;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _configProvider = _interopRequireDefault(require("../components/config-provider")); // 不从'../index.js'引ConfigProvider，避免循环依赖


function withWindConfig(Wrapped) {
  var ConfifgConsumer = _configProvider["default"].Consumer;

  var HOC = function HOC(props) {
    return _react["default"].createElement(ConfifgConsumer, null, function (context) {
      return _react["default"].createElement(Wrapped, (0, _extends2["default"])({}, props, {
        windConfig: context
      }));
    });
  };

  (0, _hoistNonReactStatics["default"])(HOC, Wrapped);
  return HOC;
}